import { useTranslation } from 'react-i18next';
import { useOneTimeReportStore } from '../../store';
import { useEffect } from 'react';
import style from '../../index.module.less';
import { Stack, TextLabel, Textarea } from '@tonic-one/react';
import { Info } from '@Components/Common/Info';
const Message = () => {
  const { t } = useTranslation();
  //getter
  const message = useOneTimeReportStore((store) => store.notification.message);

  //setter
  const setMessage = useOneTimeReportStore((store) => store.setMessage);

  //register
  const register = useOneTimeReportStore(
    (store) => store.registerResetCallback
  );
  const unregister = useOneTimeReportStore(
    (store) => store.unregisterResetCallback
  );

  useEffect(() => {
    const cb = () => setMessage('');
    register(cb);
    return () => unregister(cb);
  }, []);

  return (
    <>
      <TextLabel className={style.itemLabel}>
        {t('reportCommon.labels.message')}:
        <Info content={t('reportCommon.tips.hints.message')} />
      </TextLabel>
      <Stack spacing="12px">
        <Textarea
          mt="1x"
          rows={1}
          placeholder={t('reportCommon.placeholders.optional')}
          value={message}
          onChange={(e: any) => setMessage(e.target.value)}
          maxLength={1024}
          width={400}
        />
      </Stack>
    </>
  );
};

export default Message;
